import React from 'react';
import './style.scss';
import clsx from 'clsx';
import LoadableImage from '../../loadableImage';
import { IFightNft } from '../../../../interfaces/FightNft';

interface Props {
  nft: IFightNft;
  disabled?: boolean;
  className?: string;
  loading?: boolean;
}

const NftImage = ({ nft, className, disabled, loading }: Props) => (
  <LoadableImage
    src={nft.image}
    className={clsx('nft-image', disabled && 'nft-image-disabled', className)}
    loaderSize={120}
    loading={loading}
  />
);

export default NftImage;
